import type { IconType } from 'react-icons';
import { FaPlus, FaTrashCan } from 'react-icons/fa6';

const BUTTON_SYMBOL_ICONS = {
  plus: FaPlus,
  trash: FaTrashCan,
} as const satisfies Record<string, IconType>;

export function resolveButtonSymbolIcon(
  symbolName: string | undefined,
): IconType | undefined {
  if (symbolName === undefined) {
    return undefined;
  }

  const normalized = symbolName.trim().toLowerCase();
  if (normalized.length === 0) {
    return undefined;
  }

  if (normalized in BUTTON_SYMBOL_ICONS) {
    return BUTTON_SYMBOL_ICONS[normalized as keyof typeof BUTTON_SYMBOL_ICONS];
  }

  if (normalized.startsWith('plus')) {
    return BUTTON_SYMBOL_ICONS.plus;
  }
  if (normalized.startsWith('trash')) {
    return BUTTON_SYMBOL_ICONS.trash;
  }

  return undefined;
}
